// import AboutMe from './components/about-me';
import { BrowserRouter as Router, Route, Routes, Switch } from 'react-router-dom';
import './App.css';
// import List from './components/List/List';
// import NestedList from './components/List/NestedList';
// import Ref from './Hooks/Ref';
// import Contact2 from './page2/Contact2';
// import Home2 from './page2/Home2';
// import Product2 from './page2/Product2';
// import Navigation from './Navigation/Navigation';
// import { Router } from 'react-router-dom';
// import Contact from './page/Contact';
// import Home from './page/Home';
// import Product from './page/Product';
// import SearchBar2 from './components/Search_Bar2/SearchBar2';
// import UseState from './Hooks/UseState';
// import Interview from './components/Interview_Question/Interview';
// import ComponentDidMounting from './LifeCycleMethod/ComponentDidMounting';
// import ComponentDidUpdate from './LifeCycleMethod/ComponentDidUpdate';
// import ShouldComponentUpdate from './LifeCycleMethod/ShouldComponentUpdate';
// import ComponentWillUnmount1 from './LifeCycleMethod/ComponentWillUnmount1';
// import UseEffect from './Hooks/UseEffect';
// import ControlledComponent from './components/Cntrl&UncntrlComponent/ControlledComponent';
// import UncontrolledComponent from './components/Cntrl&UncntrlComponent/UncontrolledComponent';
// import HighOrderComponent from './components/Cntrl&UncntrlComponent/HighOrderComponent';


// import PreNavBar from "./Mi_Store_Clone/PreNavBar";
// import Navbar from './Mi_Store_Clone/Navbar';
// import Slider from './Mi_Store_Clone/Slider';
// import data from "./data/data.json"
// import Offers from "./Mi_Store_Clone/Offers";
// import Heading from "./Mi_Store_Clone/Heading";
// import StarProducts from "./Mi_Store_Clone/StarProducts";
// import HotAccessoriesMenu from "./Mi_Store_Clone/HotAccessoriesMenu";
// import HotAccessories from './Mi_Store_Clone/HotAccessories';
// import ProductReviews from './Mi_Store_Clone/ProductReviews';
// import Videos from './Mi_Store_Clone/Videos';
// import Banner from "./Mi_Store_Clone/Banner.js"
// import Footer from "./Mi_Store_Clone/Footer.js"
// import NavOptios from "./Mi_Store_Clone/NavOptios.js"


import Weather from './Weather_App/Weather';

function App() {
  // function getData() {
  //   alert("hello from app component")
  // }
  return (
    <div className="App">
      {/* <AboutMe name="Arbaj khan " favoriteGame="cricket" age="23" />  */}
      {/* <main>
      // <Switch>
      // <Route path="/home" >
      //   <Home />
      // </Route>
      // <Route path="/contact" >
      //   <Contact />
      // </Route>
      // <Route path="/product" >
      //   <Product />
      // </Route>
      // </Switch>
      // </main> */}
      {/* <Navigation />
      <Router>
        <Route path="/home2" element={<Home2/>} />
        <Route path="/contact2" element={<Contact2/>} />
        <Route path="/product2" element={<Product2/>} />
      </Router> */}
      {/* <SearchBar2 /> */}
      {/* <UseState /> */}
      {/* <Interview data={getData} /> */}
      {/* <ComponentDidMounting /> */}
      {/* <ComponentDidUpdate /> */}
      {/* <ShouldComponentUpdate/> */}
      {/* <ComponentWillUnmount1/> */}
      {/* <UseEffect/> */}
      {/* <NestedList /> */}
      {/* <Ref /> */}
      {/* <List/> */}
      {/* <ControlledComponent/> */}
      {/* <UncontrolledComponent /> */}
      {/* <HighOrderComponent /> */}



      {/* <Router>
        <PreNavBar />
        <Navbar />
        <NavOptios miPhones={data.miPhones} redmiPhones={data.redmiPhones} tv={data.tv} laptop={data.laptop} fitnessAndLifeStyle={data.fitnessAndLifeStyle} home={data.home} audio={data.audio} accessories={data.accessories} />
        <Slider start={data.banner.start} />
        <Offers offer={data.offer} />
        <Heading text="STAR PRODUCTS" />
        <StarProducts starProducts={data.starProduct} />
        <Heading text="HOT ACCESSORIES" />
        <HotAccessoriesMenu />
        <Routes>
          <Route exact path="/music" element={<HotAccessories music={data.hotAccessories.music} musicCover={data.hotAccessoriesCover.music} />} />
          <Route exact path="/smartDevice" element={<HotAccessories smartDevice={data.hotAccessories.smartDevice} smartDeviceCover={data.hotAccessoriesCover.smartDevice} />} />
          <Route exact path="/home" element={<HotAccessories home={data.hotAccessories.home} homeCover={data.hotAccessoriesCover.home} />} />
          <Route exact path="/lifeStyle" element={<HotAccessories lifeStyle={data.hotAccessories.lifeStyle} lifeStyleCover={data.hotAccessoriesCover.lifeStyle} />} />
          <Route exact path="/MobileAccessories" element={<HotAccessories mobileAccessories={data.hotAccessories.mobileAccessories} mobileAccessoriesCover={data.hotAccessoriesCover.mobileAccessories} />} />
        </Routes>
        <Heading text="Product Reviews" />
        <ProductReviews productReviews={data.productReviews} />
        <Heading text="VIDEOS" />
        <Videos videos={data.videos} />
        <Heading text="IN THE PRESS" />
        <Banner banner={data.banner} />
        <Footer footer={data.footer} />
      </Router> */}



      <Weather/>

    </div >
  );
}

export default App;
